import { createContext, useContext, ReactNode } from 'react';
import { useMatrix } from '../hooks/useMatrix';
import { useIdMapLoader } from '../hooks/useIdMapLoader';
import {useCallStateRepair} from '../hooks/useCallStateRepair';
import {useChatNotificationMuteSync} from '../hooks/useChatNotificationMuteSync.ts';
import {useReportDesktopConnection} from '../hooks/useReportDesktopConnection.ts';

export const MatrixContext = createContext<ReturnType<typeof useMatrix> | null>(null);

export const MatrixProvider = ({ children }: { children: ReactNode }) => {
    useChatNotificationMuteSync();
    useReportDesktopConnection();
    const matrix = useMatrix();
    useIdMapLoader();
    useCallStateRepair(matrix);
    return (
        <MatrixContext.Provider value={matrix}>
            {children}
        </MatrixContext.Provider>
    );
};

export const useMatrixContext = () => {
    const context = useContext(MatrixContext);
    if (!context) {
        throw new Error('useMatrixContext must be used within MatrixProvider');
    }
    return context;
};
